import { ICowsList } from 'models/ICattlesData'

/** Same condition as the yellow warning row in CattlesTable. */
export const hasFarmCowNumber = (cow: Pick<ICowsList, 'farm_cow_number'>) => {
	const value = cow.farm_cow_number as unknown

	if (value == null) return false
	if (typeof value === 'string') return value.trim() !== ''
	if (typeof value === 'number') return value !== 0

	return Boolean(value)
}

export const filterCowsWithFarmCowNumber = (cows: ICowsList[]) =>
	cows.filter(hasFarmCowNumber)
